import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import useBookFormPage from "@Pages/BookForm/useBookFormPage";
import NotFound from "@Pages/NotFound";
import AmberCopilotWrapper from "@Components/Chatbot/AmberCopilotWrapper";

const PaymentPage = loadable(() => import("./PaymentPage"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const { isError, isLoading, showFullPageLoader } = useBookFormPage({
    ...props,
    isPaymentPage: true,
  });

  if (isError) {
    return <NotFound isStatus500 {...props} />;
  }

  if (showFullPageLoader) {
    return <FullPageLoader />;
  }
  return (
    <ErrorBoundary>
      <PaymentPage {...props} isLoading={isLoading} />
      <AmberCopilotWrapper />
    </ErrorBoundary>
  );
};
